export default __webpack_public_path__ + "static/media/ES.827b32da.svg";